import AVV from './AVV.js'
import studio from './studio.js'
import musteri from './musteri.js'


export const Musteri = [...musteri]
export const Avv = [...AVV]
export const Studio = [...studio]
